import {
  Button,
  Flex,
  Icon,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  useOutsideClick,
} from "@chakra-ui/react";
import { t } from "i18next";
import { useRef, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";

interface Props {
  confirmRemoval: () => Promise<void>;
  size?: string;
}

export const RemoveFileButton = ({ confirmRemoval, size }: Props) => {
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const ref = useRef(null);

  useOutsideClick({
    ref: ref,
    handler: () => setShowConfirmation(false),
  });

  return (
    <Flex ref={ref}>
      <Popover
        returnFocusOnClose={true}
        isOpen={showConfirmation}
        placement="bottom"
        closeOnBlur={true}
        offset={[0, -3]}
      >
        <PopoverTrigger>
          <IconButton
            aria-label="Remove file"
            display="flex"
            alignItems="center"
            justifyContent="center"
            variant="ghost"
            color="smMuted"
            size={size}
            onClick={async (e) => {
              e.stopPropagation();
              setShowConfirmation(true);
            }}
            icon={<Icon as={FaTrashAlt} />}
          />
        </PopoverTrigger>
        <PopoverContent width="fit-content" p="1">
          <PopoverArrow />
          <Button
            rightIcon={<Icon as={FaTrashAlt} />}
            colorScheme="red"
            variant="ghost"
            size={size}
            isLoading={isDeleting}
            onClick={async (e) => {
              e.stopPropagation();
              setIsDeleting(true);
              await confirmRemoval();
              setIsDeleting(false);
              setShowConfirmation(false);
            }}
          >
            {t("Confirm")}
          </Button>
        </PopoverContent>
      </Popover>
    </Flex>
  );
};
